import { NgModule } from '@angular/core';
import { NavigationService } from '@spartacus/storefront';
import { CustomNavigationService } from './service/custom-navigation.service';

@NgModule({
  providers: [
    {
      provide: NavigationService,
      useExisting: CustomNavigationService,
    },
  ],
})
export class MainNavigationFeatureModule {}
